const has = Object.prototype.hasOwnProperty; // cache the lookup once, in module scope.
export const hasProperty = (object, key) => has.call(object, key);

export const isNonEmptyObject = (obj) => obj && typeof obj === "object" && Object.keys(obj).length > 0;
